import { render, staticRenderFns } from "./SlideComponent.vue?vue&type=template&id=281bd726"
import script from "./SlideComponent.vue?vue&type=script&lang=js"
export * from "./SlideComponent.vue?vue&type=script&lang=js"
import style0 from "./SlideComponent.vue?vue&type=style&index=0&id=281bd726&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports